import { BaseDashboardActionItem, LoadableTypography } from '@uplift/ui-v2';
import React from 'react';
import { PriorityHigh } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useHistory } from 'react-router';
import { ROUTING_CONFIG } from '@uplift/constants';
import { StatesLabel } from './components/StatesLabel';


type ExpiringCollaborativeAgreementsProps = {
  stateIds: string[];
};


export const ExpiringCollaborativeAgreements: React.VFC<ExpiringCollaborativeAgreementsProps> = (props) => {
  const history = useHistory();
  const multiple = props.stateIds.length > 1;

  return (
    <BaseDashboardActionItem
      title={<Typography>Renew <b>{props.stateIds.length}</b> expiring Collaborative Practice Agreement{multiple ? 's' : ''}</Typography>}
      body={(
        <React.Suspense
          fallback={(
            <Box sx={{ mt: -1 }}>
              <LoadableTypography variant="body2" width="300px" />
            </Box>
          )}
        >
          <Typography variant="body2" sx={{ mt: -1 }}>
            <StatesLabel stateIds={props.stateIds} /> agreement{multiple ? 's' : ''} expires soon — renew to avoid disruption to your patients in this state{multiple ? 's' : ''}.
          </Typography>
        </React.Suspense>
      )}
      color="warning"
      icon={<PriorityHigh />}
      action={{
        handleClick: () => {
          history.push(ROUTING_CONFIG.documentsCenter);
        },
        text: 'Renew'
      }}
    />
  );
};
